document.querySelectorAll('.size-guide-table-wrapper').forEach((wrapper) => {
  const table = wrapper.querySelector('.size-guide-table');
  const buttons = wrapper.querySelectorAll('.size-guide-table__unit-btn');

  if (!table || !buttons.length) return;

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const unit = button.dataset.unitBtn;
      table.setAttribute('data-unit', unit);
      buttons.forEach((b) => b.classList.toggle('is-active', b === button));
    });
  });
});
